(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-article"]) return;
  try {
    

  if (!customElements.get('ea-scroll-statement')) {
    class EditorialScrollStatement extends HTMLElement {
      connectedCallback() {
        this.heading = this.querySelector('h2');
        if (!this.heading || this.controller) return;
        this.controller = new AbortController();
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.schedule = () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.update();
          });
        };
        if (!this.words) {
          const text = this.heading.textContent;
          this.heading.setAttribute('aria-label', text);
          const fragment = document.createDocumentFragment();
          this.words = [];
          for (const token of text.match(/\S+|\s+/gu) || []) {
            if (/^\s+$/u.test(token)) {
              fragment.append(document.createTextNode(token));
            } else {
              const word = document.createElement('span');
              word.className = 'ea__statement-word';
              word.setAttribute('aria-hidden', 'true');
              word.textContent = token;
              this.words.push(word);
              fragment.append(word);
            }
          }
          this.heading.replaceChildren(fragment);
        }
        const options = { passive: true, signal: this.controller.signal };
        window.addEventListener('scroll', this.schedule, options);
        document.addEventListener('scroll', this.schedule, { ...options, capture: true });
        window.addEventListener('resize', this.schedule, options);
        this.motion.addEventListener('change', this.schedule, { signal: this.controller.signal });
        this.observer = new ResizeObserver(this.schedule);
        this.observer.observe(this.heading);
        this.update();
      }

      update() {
        const rect = this.heading.getBoundingClientRect();
        const viewport = window.innerHeight;
        const distance = Math.max(viewport * 0.35, rect.height);
        const progress = Math.min(1, Math.max(0, (viewport * 0.95 - rect.top) / distance));
        const count = this.motion.matches ? this.words.length : Math.floor(progress * this.words.length);
        this.classList.toggle('ea__scroll-active', !this.motion.matches);
        for (let index = 0; index < this.words.length; index++) {
          this.words[index].classList.toggle('is-lit', index < count);
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
      }
    }
    customElements.define('ea-scroll-statement', EditorialScrollStatement);
  }

  if (!customElements.get('ea-scroll-motion')) {
    class EditorialScrollMotion extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.targets = [...this.querySelectorAll('.ea__body, .ea__faq-content, .ea__hero-media, .ea__faq-media, .ea__editorial')];
        this.progress = new Map();
        this.schedule = () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.update();
          });
        };
        const options = { passive: true, signal: this.controller.signal };
        document.addEventListener('scroll', this.schedule, { ...options, capture: true });
        window.addEventListener('scroll', this.schedule, options);
        window.addEventListener('resize', this.schedule, options);
        this.motion.addEventListener('change', this.schedule, { signal: this.controller.signal });
        this.observer = new ResizeObserver(this.schedule);
        this.observer.observe(this.parentElement);
        this.update();
      }
      update() {
        const viewport = innerHeight;
        const shift = viewport > 0 && innerWidth <= 749 ? 8 : 12;
        const measurements = this.targets.map(target => {
          const previous = this.progress.get(target) ?? 1;
          const content = target.matches('.ea__body, .ea__faq-content');
          const top = target.getBoundingClientRect().top - (content ? (1 - previous) * shift : 0);
          const progress = this.motion.matches ? 1 : Math.max(0, Math.min(1, (viewport * .95 - top) / (viewport * .28)));
          return { target, progress };
        });
        for (const { target, progress } of measurements) {
          this.progress.set(target, progress);
          target.style.setProperty('--ea-reveal', progress);
        }
        this.classList.toggle('ea-motion-ready', !this.motion.matches);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.classList.remove('ea-motion-ready');
        this.targets?.forEach(target => target.style.removeProperty('--ea-reveal'));
      }
    }
    customElements.define('ea-scroll-motion', EditorialScrollMotion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
